import { Component } from '@angular/core';
import { MediaPanelInfo } from '../../../../../models/datamodel/mediasource.model';
import { SettingsService } from '../../../../../services/settings.service';
import { BaseMediaSourcePanel } from '../basemediasource.panel';

@Component({
    selector: 'sharepoint-panel',
    templateUrl: './sharepoint.panel.html',
    styleUrls: ['./sharepoint.panel.css']
})
export class SharePointPanel extends BaseMediaSourcePanel {

    get RedirectUrl(): string {
        const ret = SettingsService.API_BASE_URL.getValue() + 'config/api/media/oauth/authorizemicrosoft';
        this.MediaSource.RedirectUrl = ret;
        this.MediaSource.Private = true; 
        return ret;
    }

    set RedirectUrl(val) {
        if (val != this.MediaSource.RedirectUrl) {
            this.MediaSource.RedirectUrl = val;
        }
    }

    authenticate(): void {
        const authstring = 'https://login.microsoftonline.com/' + this.MediaSource.TenantId + '/oauth2/v2.0/authorize?client_id=' + this.MediaSource.ClientId + '&response_type=code&redirect_uri=' + this.MediaSource.RedirectUrl + '&state=' + this.MediaSource.SID + '&response_mode=query&scope=offline_access https://graph.microsoft.com/Files.ReadWrite.All https://graph.microsoft.com/Sites.ReadWrite.All https://graph.microsoft.com/User.Read';
        window.open(authstring, '_blank');
    }

    static GetInfo(): MediaPanelInfo {
        return { 
            ControlType: SharePointPanel,
            MediaType: '996019d8-abb7-47a6-a33e-237a0d799c53'
        };
    }
}
